import { IAppState } from '@state/types';
import { Industry } from './types';

export const getIndustries = (state: IAppState): Industry[] => state.industries.industries;
